import React from 'react';
import PageMeta from '../components/PageMeta';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { 
  CheckCircle2, Award, Users, BookOpen, Sparkles, TrendingUp, BarChart3, 
  Target, Globe, Shield, Star, Briefcase, Clock, Zap, Heart, ArrowRight,
  Linkedin, Twitter, Facebook, Instagram, Mail, MapPin, Phone, ExternalLink,
  ChevronRight, TrendingUp as Growth, Code, Database, Cpu, Palette, Video,
  Megaphone, FileText, Settings, Layers, Monitor, PenTool, Calendar
} from 'lucide-react';
import EnrollmentForm from '../components/EnrollmentForm';
import EnquireNowButton from '../components/EnquireNowButton';
import SiteFooter from '../components/SiteFooter';
import MobileCTABar from '../components/MobileCTABar';
import SiteHeader from '../components/SiteHeader';
import BrandLogo from '../components/BrandLogo';
import Chatbot from '../components/Chatbot';
import TrustStrip from '../components/TrustStrip';
import TransformationJourney from '../components/TransformationJourney';
import WhyJoinUs from '../components/WhyJoinUs';
import CareerOutcomes from '../components/CareerOutcomes';
import LogoWall from '../components/LogoWall';
import MasterclassFunnel from '../components/MasterclassFunnel';
import StickyMobileCTA from '../components/StickyMobileCTA';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  const courses = [
    {
      id: 8,
      title: 'Online Performance Marketing Course – 100% Job Guarantee',
      description: '4 Months Intensive Program. Master Meta Ads, Google Ads, Analytics & AI-Powered Strategies. Get placed with our 100% Job Guarantee.',
      icon: <Shield className="w-8 h-8 text-yellow-500" />,
      duration: '4 Months',
      level: '100% Job Guarantee',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop&q=80',
      isLive: true,
      badge: '🛡️ NEW • Batch: New Batches Every Month • Enrollment: Limited Time',
      detailUrl: '/performance-marketing'
    },
    {
      id: 7,
      title: 'Certified Specialist in Digital Growth & Performance Marketing (CSDGPM)',
      description: 'Exemplar Global accredited specialist program. Master performance marketing, analytics, growth frameworks, and digital strategy with 100% industry expert-led training.',
      icon: <Target className="w-8 h-8 text-blue-600" />,
      duration: '6 Months',
      level: 'Specialist Level',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=500&fit=crop&q=80',
      isLive: true,
      badge: '🔥 Batch: New Batches Every Month • Enrollment: Limited Time',
      detailUrl: '/csdgpm-offer'
    },
    {
      id: 1,
      title: 'Certified Professional in Applied Machine Learning (CPAML)',
      description: 'Master machine learning fundamentals with hands-on projects and real-world applications.',
      icon: <Sparkles className="w-8 h-8 text-gray-400" />,
      duration: '3 Months',
      level: 'Professional Certificate',
      image: 'https://customer-assets-agu9un31.emergentagent.net/job_8d33ea52-c764-4e32-b8e2-de0e8040a6fa/artifacts/qmwa0e8d_ai-touch-technology-concept-glowing-interface-conn-2026-01-11-08-36-44-utc.webp',
      isLive: false,
      detailUrl: '/courses/cpaml',
      comingSoon: true
    },
    {
      id: 2,
      title: 'Certified Specialist in Machine Learning & Automation (CSMLA)',
      description: 'Advanced ML automation techniques, MLOps, and deployment strategies.',
      icon: <TrendingUp className="w-8 h-8 text-gray-400" />,
      duration: '6 Months',
      level: 'Specialist Level',
      image: 'https://customer-assets-agu9un31.emergentagent.net/job_8d33ea52-c764-4e32-b8e2-de0e8040a6fa/artifacts/7972pqhd_ai-robot-working-in-the-office-2026-01-07-00-29-03-utc.webp',
      isLive: false,
      detailUrl: '/courses/csmla',
      comingSoon: true
    },
    {
      id: 3,
      title: 'Professional Certificate in Business & Data Analytics (PCBDA)',
      description: 'Transform business data into actionable insights using advanced analytics.',
      icon: <BarChart3 className="w-8 h-8 text-gray-400" />,
      duration: '3 Months',
      level: 'Professional Certificate',
      image: 'https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3NjMyMDczMjN8MA&ixlib=rb-4.1.0&q=85&w=800&h=500&fit=crop',
      isLive: false,
      detailUrl: '/courses/pcbda',
      comingSoon: true
    },
    {
      id: 4,
      title: 'Advanced Diploma in Applied Data Science & Predictive Modeling (ADADSPM)',
      description: 'Deep dive into data science, statistical modeling, and predictive analytics.',
      icon: <Target className="w-8 h-8 text-gray-400" />,
      duration: '6 Months',
      level: 'Advanced Diploma',
      image: 'https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxkYXRhJTIwc2NpZW5jZXxlbnwwfHx8fDE3NjMyMDczMjd8MA&ixlib=rb-4.1.0&q=85&w=800&h=500&fit=crop',
      isLive: false,
      detailUrl: '/courses/adadspm',
      comingSoon: true
    },
    {
      id: 5,
      title: 'Certified Cloud Computing Specialist (CCCS)',
      description: 'Master cloud platforms (AWS, Azure, GCP) and cloud-native development.',
      icon: <Globe className="w-8 h-8 text-gray-400" />,
      duration: '3 Months',
      level: 'Professional Certificate',
      image: 'https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg?auto=compress&cs=tinysrgb&w=800&h=500&fit=crop',
      isLive: false,
      detailUrl: '/courses/cccs',
      comingSoon: true
    },
    {
      id: 6,
      title: 'Professional Certificate in Digital Marketing Strategies (PCDMS)',
      description: 'Learn comprehensive digital marketing including SEO, social media, and analytics.',
      icon: <TrendingUp className="w-8 h-8 text-gray-400" />,
      duration: '3 Months',
      level: 'Professional Certificate',
      image: 'https://workshoplibrary.com/public/storage/freedemo/17485526331118228328.jpg',
      isLive: false,
      detailUrl: '/courses/pcdms',
      comingSoon: true
    }
  ];

  const workshops = [
    {
      id: 1,
      title: 'Photo Editing with AI',
      description: 'Master AI-powered photo editing tools and techniques',
      duration: '4 hours',
      icon: <Palette className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=300&fit=crop&q=80',
      color: 'from-pink-400 to-rose-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 2,
      title: 'Video Production & Editing with AI',
      description: 'Create professional videos using AI tools',
      duration: '5 hours',
      icon: <Video className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=400&h=300&fit=crop&q=80',
      color: 'from-purple-400 to-indigo-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 3,
      title: 'AI-Powered Social Media Booster',
      description: 'Amplify your social presence with AI automation',
      duration: '3 hours',
      icon: <Megaphone className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1683721003111-070bcc053d8b?w=400&h=300&fit=crop&q=80',
      color: 'from-blue-400 to-cyan-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 4,
      title: 'LinkedIn Automation using AI',
      description: 'Automate LinkedIn outreach and engagement',
      duration: '4 hours',
      icon: <Linkedin className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1611944212129-29977ae1398c?w=400&h=300&fit=crop&q=80',
      color: 'from-blue-500 to-blue-700',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 5,
      title: 'Prompt Engineering for Beginners',
      description: 'Learn to write effective AI prompts',
      duration: '3 hours',
      icon: <FileText className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=300&fit=crop&q=80',
      color: 'from-green-400 to-emerald-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 6,
      title: 'Canva + AI Design Secrets',
      description: 'Design like a pro with Canva AI features',
      duration: '4 hours',
      icon: <Layers className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=400&h=300&fit=crop&q=80',
      color: 'from-violet-400 to-purple-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 7,
      title: 'AI Tools for Freelancers',
      description: 'Boost productivity with AI automation',
      duration: '5 hours',
      icon: <Briefcase className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop&q=80',
      color: 'from-orange-400 to-red-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 8,
      title: 'Digital Ads Auto-Optimization with AI',
      description: 'Optimize campaigns with AI-powered insights',
      duration: '6 hours',
      icon: <Target className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop&q=80',
      color: 'from-teal-400 to-cyan-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 9,
      title: 'Content Creation Mastery using AI',
      description: 'Generate high-quality content at scale',
      duration: '5 hours',
      icon: <PenTool className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1542435503-956c469947f6?w=400&h=300&fit=crop&q=80',
      color: 'from-amber-400 to-yellow-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    },
    {
      id: 10,
      title: 'AI-Powered Resume + Portfolio Builder',
      description: 'Build stunning portfolios with AI assistance',
      duration: '4 hours',
      icon: <Monitor className="w-8 h-8" />,
      image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&h=300&fit=crop&q=80',
      color: 'from-indigo-400 to-blue-500',
      startDate: 'New Batches Every Month',
      enrollmentDeadline: 'Limited Time Only'
    }
  ];

  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Digital Marketing Manager',
      company: 'Tech Startup',
      rating: 5,
      quote: 'The CSDGPM program transformed my career. The practical approach and industry insights were invaluable. Highly recommend!'
    },
    {
      name: 'Michael Chen',
      role: 'Performance Marketing Lead',
      company: 'E-commerce Brand',
      rating: 5,
      quote: 'Best investment in my professional development. The curriculum is comprehensive and immediately applicable to real-world scenarios.'
    },
    {
      name: 'Priya Sharma',
      role: 'Growth Marketing Specialist',
      company: 'SaaS Company',
      rating: 5,
      quote: 'Exemplar Global certification opened doors to senior roles. The quality of training and support exceeded my expectations.'
    }
  ];

  const industryFacts = [
    {
      icon: <BarChart3 className="w-12 h-12 text-blue-600" />,
      stat: '75%',
      title: 'Job Transformation',
      description: 'Professionals transition to higher-paying roles within 12 months',
      bgColor: 'bg-blue-50'
    },
    {
      icon: <TrendingUp className="w-12 h-12 text-green-600" />,
      stat: '$45K+',
      title: 'Average Salary Increase',
      description: 'Average annual income boost after certification completion',
      bgColor: 'bg-green-50'
    },
    {
      icon: <Target className="w-12 h-12 text-purple-600" />,
      stat: '93%',
      title: 'Career Advancement',
      description: 'Alumni achieve promotions or career pivots successfully',
      bgColor: 'bg-purple-50'
    },
    {
      icon: <Globe className="w-12 h-12 text-orange-600" />,
      stat: '150+',
      title: 'Global Hiring Partners',
      description: 'Companies actively hiring our certified professionals',
      bgColor: 'bg-orange-50'
    }
  ];

  const faqs = [
    {
      icon: <CheckCircle2 className="w-5 h-5 text-blue-600" />,
      question: 'What makes AI School for All different from other training providers?',
      answer: 'We offer Exemplar Global accredited programs with 100% industry expert-led training. Our courses combine live sessions, hands-on labs, and real-world projects with lifetime access to recorded content.'
    },
    {
      icon: <Award className="w-5 h-5 text-blue-600" />,
      question: 'Are the certifications globally recognized?',
      answer: 'Yes! Our flagship CSDGPM program is accredited by Exemplar Global, making it internationally recognized. We also prepare you for additional certifications like Google Ads and Meta Blueprint.'
    },
    {
      icon: <Clock className="w-5 h-5 text-blue-600" />,
      question: 'What is the time commitment required?',
      answer: 'Programs range from 3-6 months with 6-8 hours per week commitment. All live sessions are recorded, so you can learn at your own pace while still benefiting from real-time interactions.'
    },
    {
      icon: <Users className="w-5 h-5 text-blue-600" />,
      question: 'Do you provide career support?',
      answer: 'Yes! We provide career guidance, portfolio building support, resume reviews, and access to our network of 150+ hiring partners. Many of our alumni secure roles through our placement assistance.'
    },
    {
      icon: <Briefcase className="w-5 h-5 text-blue-600" />,
      question: 'Who should enroll in these programs?',
      answer: 'Our programs are designed for working professionals, fresh graduates, career switchers, and business owners looking to upskill in AI, data science, marketing, or cloud technologies.'
    },
    {
      icon: <Shield className="w-5 h-5 text-blue-600" />,
      question: 'What is your refund policy?',
      answer: 'We offer a 7-day money-back guarantee from the program start date. If you\'re not satisfied with the quality of training, we\'ll provide a full refund, no questions asked.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <PageMeta
        title="AI School for All | Job-Assured Courses in AI, Digital Marketing, Film Making & Game Development"
        description="Premium job-assured courses in AI, Digital Marketing, Film Making, Game Development & more. New batches every month."
        path="/"
      />
      {/* ENROLLMENT BOOSTER HEADER - Promotional Banner */}
      <div className="bg-gradient-to-r from-violet-900 via-purple-800 to-indigo-900 text-white py-2.5 px-4 shadow-lg">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <div className="flex items-center gap-2">
              <span className="text-lg">🎬</span>
              <span className="text-sm md:text-base font-medium">
                <span className="font-bold text-yellow-300">NEW Film Making, VFX &amp; Editing Course</span>
                <span className="hidden md:inline"> | New Batches Every Month | </span>
                <span className="text-yellow-300 font-semibold">Up to 63% OFF</span>
              </span>
            </div>
            <button
              onClick={() => navigate('/film-making-animation-course')}
              className="bg-gradient-to-r from-orange-400 to-amber-500 text-gray-900 hover:from-orange-500 hover:to-amber-600 px-5 py-1.5 rounded-full font-bold text-sm transition-all hover:scale-105 shadow-md flex items-center gap-1"
              data-testid="marquee-film-making-btn"
            >
              View Course
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      {/* GLOBAL SITE HEADER */}
      <SiteHeader ctaLabel="Enroll Now" ctaTo="/book-demo" />

      {/* SECTION 1: HERO WITH CINEMATIC FILM-MAKING SHOWREEL BACKGROUND */}
      <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-black">
        {/* Cinematic Ken-Burns Image Background (autoplay zoom + pan, looping) */}
        <div className="absolute inset-0 overflow-hidden">
          <div
            data-testid="hero-cinematic-bg"
            className="absolute inset-0 animate-cinematic-zoom"
            style={{
              backgroundImage: 'url("https://customer-assets.emergentagent.com/job_academy-revamp-2/artifacts/75drn3yc_Untitled%20design%20%284%29.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center right',
            }}
          />
          {/* Cinematic dark gradient + film grain overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/70 to-black/30"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/70"></div>
          <div className="absolute inset-0 opacity-40 mix-blend-overlay pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 30% 50%, rgba(251,146,60,0.15) 0%, transparent 50%)' }}></div>
          {/* Animated light rays */}
          <div className="absolute inset-0 opacity-20 pointer-events-none" style={{ background: 'repeating-linear-gradient(120deg, transparent 0 20px, rgba(255,200,100,0.05) 20px 22px)' }}></div>
        </div>

        {/* SHOWREEL MODAL — REMOVED */}
        {false && (
          <div data-testid="showreel-modal"></div>
        )}

        <div className="container mx-auto px-8 py-20 relative z-10">
          <div className="max-w-2xl">
            {/* Featured Course Badge */}
            <button
              onClick={() => navigate('/film-making-animation-course')}
              data-testid="hero-film-making-badge"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500/20 to-amber-500/20 border border-orange-400/50 backdrop-blur-sm rounded-full px-5 py-2 mb-6 hover:scale-105 transition-all cursor-pointer group"
            >
              <span className="text-lg">🔥</span>
              <span className="text-sm font-bold text-orange-300 group-hover:text-orange-200">Admissions Open For Upcoming Batches — New Batches Every Month</span>
              <ArrowRight className="w-4 h-4 text-orange-300 group-hover:translate-x-1 transition-transform" />
            </button>

            {/* Main Heading — Emotional AI Future */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white mb-5 leading-[1.05] animate-fade-up">
              Master Film Making with AI Tools,
              <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-orange-400 to-pink-400">
                Digital Marketing &amp; Future Skills
              </span>
            </h1>

            {/* Subheading */}
            <p className="text-lg md:text-2xl text-white/90 mb-6 leading-snug font-medium animate-fade-up-delay-1">
              Learn from industry experts. Build real projects. Get career-ready.
            </p>

            {/* Powered by Workshop Library - Bigger Logo + Trust Tagline */}
            <div className="flex flex-col gap-3 mb-8 animate-fade-up-delay-2">
              <div className="flex items-center gap-4 flex-wrap">
                <span className="text-base md:text-lg font-semibold text-white/90">Powered by</span>
                <img
                  src="https://customer-assets.emergentagent.com/job_eduai-portal-6/artifacts/zrncz5al_Untitled%20%281000%20x%20500%20px%29%20%281%29.jpg"
                  alt="Workshop Library"
                  className="h-14 md:h-20 object-contain rounded-md shadow-lg shadow-yellow-500/20"
                  data-testid="workshop-library-logo" decoding="async" fetchPriority="high" loading="eager" />
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <Shield className="w-4 h-4 text-yellow-400 flex-shrink-0" />
                <span className="text-sm md:text-base text-yellow-200 font-semibold">
                  Trusted Learning Ecosystem by Infinite Web Marketing Pvt. Ltd. &middot; 15+ Years Industry Experience
                </span>
              </div>
            </div>

            {/* CTA Buttons — 3 PRIMARY ACTIONS */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 mb-8 animate-fade-up-delay-3">
              <button
                onClick={() => document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' })}
                data-testid="hero-cta-book-demo"
                className="glow-cta px-7 py-4 rounded-xl font-black text-base shadow-xl hover:scale-105 transition-transform inline-flex items-center justify-center gap-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-black"
              >
                Book Free Demo
                <ArrowRight className="w-5 h-5" />
              </button>
              <button
                onClick={() => document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' })}
                data-testid="hero-cta-curriculum"
                className="px-7 py-4 rounded-xl font-bold text-base bg-white/10 backdrop-blur-md border border-white/30 text-white hover:bg-white/15 transition-all inline-flex items-center justify-center gap-2"
              >
                Download Curriculum
              </button>
              <a
                href="https://wa.me/919891550666?text=Hi%2C%20I%20want%20counseling%20for%20AI%20courses."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-cta-whatsapp"
                className="px-7 py-4 rounded-xl font-bold text-base bg-green-500 hover:bg-green-600 text-white transition-all inline-flex items-center justify-center gap-2"
              >
                <Phone className="w-4 h-4" /> WhatsApp Counselor
              </a>
            </div>

            {/* Next Batch indicator */}
            <p data-testid="hero-next-batch" className="text-sm text-yellow-200/90 mb-6 inline-flex items-center gap-2 bg-black/30 backdrop-blur-sm border border-yellow-400/30 rounded-full px-4 py-2 self-start">
              <Calendar className="w-4 h-4 text-yellow-300" />
              <span className="font-semibold">Next Status: <span className="text-yellow-300 font-black">Admissions Open</span></span>
              <span className="text-red-300">·</span>
              <span className="text-red-300 font-semibold">Seats Filling Fast</span>
            </p>

            {/* Trust Badges Row — Floating Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3">
              {[
                { icon: <Users className="w-4 h-4" />, label: '10,000+ Learners' },
                { icon: <Award className="w-4 h-4" />, label: '50+ Industry Mentors' },
                { icon: <Cpu className="w-4 h-4" />, label: 'AI-Powered Curriculum' },
                { icon: <Briefcase className="w-4 h-4" />, label: 'Placement Assistance' },
                { icon: <Sparkles className="w-4 h-4" />, label: 'Live Practical Projects' }
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-2 px-3 py-2 rounded-lg border border-white/20 bg-white/5 backdrop-blur-sm">
                  <span className="text-yellow-300">{b.icon}</span>
                  <span className="text-white font-semibold text-[11px] sm:text-xs">{b.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Trust strip + transformation journey directly under hero */}
      <TrustStrip />
      <TransformationJourney />

      {/* COURSE EXPLORER — Premium Job Assured Courses (light, Apple/MasterClass aesthetic) */}
      <section data-testid="course-explorer-section" className="relative py-28 px-6 overflow-hidden bg-white">
        {/* Light decorative accents */}
        <div className="absolute inset-0 opacity-[0.5]" style={{ backgroundImage: 'radial-gradient(circle at 20% 10%, rgba(139,92,246,0.08) 0%, transparent 40%), radial-gradient(circle at 80% 90%, rgba(251,146,60,0.08) 0%, transparent 40%)' }} />
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-violet-500 via-orange-400 to-emerald-500 opacity-60"></div>

        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="text-center mb-6">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 rounded-full px-5 py-2 mb-6">
              <Sparkles className="w-4 h-4 text-yellow-400 animate-pulse" />
              <span className="text-sm font-bold text-yellow-300 uppercase tracking-wider">Admissions Open Admissions Open</span>
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-slate-900 mb-4 tracking-tight">
              Our Upcoming<br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-600 via-orange-500 to-rose-600">Job Assured Courses</span>
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto font-medium">
              Industry-ready programs with placement assistance, real-world projects &amp; professional certification
            </p>
            <p className="text-sm text-slate-500 mt-3 inline-flex items-center gap-2"><Calendar className="w-4 h-4 text-orange-500" /> Next Status: <span className="font-bold text-slate-800">Admissions Open</span></p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
            {[
              { id: 'ai-bootcamp', link: '/ai-bootcamp', img: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&h=250&fit=crop&q=80', dur: '3 Months', badge: '50% OFF', tag: 'Job Assured', tagColor: 'bg-green-500', label: 'For Students (8th–12th)', title: 'AI Bootcamp for School Students', desc: 'Live AI training, international certification & summer batch discounts.', color: 'violet', price: null, oldPrice: null, start: 'New Batches Every Month' },
              { id: 'performance-marketing', link: '/performance-marketing', img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&h=250&fit=crop&q=80', dur: '4 Months', badge: 'Job Guarantee', tag: 'Job Assured', tagColor: 'bg-green-500', label: 'Job-Ready Program', title: 'Performance Marketing Course', desc: 'Master Meta Ads, Google Ads, analytics & AI-powered marketing.', color: 'blue', price: null, oldPrice: null, start: 'New Batches Every Month' },
              { id: 'film-making', link: '/film-making-animation-course', img: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=500&h=250&fit=crop&q=80', dur: '4 Months', badge: '63% OFF', tag: 'Job Assured', tagColor: 'bg-green-500', label: 'Film + VFX + AI Cinema', title: 'Film Making & Cinematic Animation', desc: 'VFX, editing, Blender cinematics, AI filmmaking & showreel creation.', color: 'orange', price: '35,000', oldPrice: '95,000', start: 'New Batches Every Month' },
              { id: 'game-dev', link: '/game-development-course', img: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=500&h=250&fit=crop&q=80', dur: '4 Months', badge: '63% OFF', tag: 'Job Assured', tagColor: 'bg-green-500', label: 'Unity + Unreal + Blender', title: 'Game Development Course', desc: 'Build & publish real games with 3D art, physics & monetization.', color: 'emerald', price: '35,000', oldPrice: '95,000', start: 'New Batches Every Month' },
              { id: 'jewellery', link: '/jewellery-designing-course', img: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500&h=250&fit=crop&q=80', dur: '2 Months', badge: '49% OFF', tag: 'Limited Seats', tagColor: 'bg-red-500', label: 'Blender + 3D Visualization', title: 'Jewellery Designing in Blender', desc: '3D modelling, photorealistic rendering & luxury product visualization.', color: 'yellow', price: '25,000', oldPrice: '49,000', start: 'New Batches Every Month' },
              { id: 'blender', link: '/complete-blender-character-design-course', img: 'https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?w=500&h=250&fit=crop&q=80', dur: '4 Months', badge: '60% OFF', tag: 'Job Assured', tagColor: 'bg-green-500', label: 'Sculpting + Animation + Render', title: 'Blender & Character Design', desc: 'Character sculpting, rigging, animation & showreel creation.', color: 'purple', price: '30,000', oldPrice: '75,000', start: 'New Batches Every Month' }
            ].map((c, i) => (
              <div key={c.id} data-testid={`course-card-${c.id}`}
                className={`group relative rounded-3xl overflow-hidden bg-white border border-slate-200 shadow-sm transition-all duration-500 hover:border-${c.color}-400/60 hover:shadow-2xl hover:-translate-y-2 hover:shadow-${c.color}-500/10`}>
                <div onClick={() => navigate(c.link)} className="h-48 overflow-hidden relative cursor-pointer">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" decoding="async" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                  <div className="absolute top-3 left-3 flex gap-2">
                    <span className={`bg-${c.color}-500 text-white text-[10px] font-black uppercase px-2.5 py-1 rounded-md tracking-wider shadow-md`}>{c.dur}</span>
                    <span className="bg-amber-400 text-amber-950 text-[10px] font-black uppercase px-2.5 py-1 rounded-md tracking-wider shadow-md">{c.badge}</span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className={`${c.tagColor} text-white text-[10px] font-black px-2 py-1 rounded-md shadow-md ${c.tag === 'Limited Seats' ? 'animate-pulse' : ''}`}>{c.tag}</span>
                  </div>
                  {/* Urgency mini-label */}
                  <div className="absolute bottom-3 left-3">
                    <span className="inline-flex items-center gap-1 bg-white/95 text-slate-900 text-[10px] font-bold px-2.5 py-1 rounded-full shadow">
                      <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
                      {['Admissions Open','Admissions Open','Seats Filling Fast','Weekend Batch Available'][i % 4]}
                    </span>
                  </div>
                </div>
                <div className="p-6 bg-white">
                  <span className={`text-[10px] uppercase tracking-[0.2em] font-bold text-${c.color}-600`}>{c.label}</span>
                  <h3 className="text-xl font-black text-slate-900 mt-1 mb-2 leading-tight">{c.title}</h3>
                  <p className="text-slate-500 text-sm mb-5 leading-relaxed">{c.desc}</p>
                  <div className="flex items-center justify-between mb-1">
                    {c.price ? (
                      <div className="flex items-baseline gap-2">
                        <span className="text-xs text-slate-400 line-through">&#8377;{c.oldPrice}</span>
                        <span className={`text-lg font-black text-${c.color}-600`}>&#8377;{c.price}</span>
                      </div>
                    ) : (
                      <span className={`text-sm font-bold text-${c.color}-600`}>Free Career Counseling</span>
                    )}
                    <button
                      onClick={(e) => { e.stopPropagation(); navigate(c.link); }}
                      className={`text-xs font-bold text-slate-700 hover:text-${c.color}-600 underline underline-offset-4`}
                    >
                      View Details
                    </button>
                  </div>
                  <div className="text-xs text-slate-500 inline-flex items-center gap-1 mb-4">
                    <Calendar className="w-3.5 h-3.5" /> Status: <span className={`text-${c.color}-600 font-bold`}>{c.start || 'New Batches Every Month'}</span>
                  </div>
                  <button
                    onClick={(e) => { e.stopPropagation(); navigate(c.link); }}
                    data-testid={`enroll-cta-${c.id}`}
                    className={`w-full inline-flex items-center justify-center gap-2 text-white font-black py-3 rounded-xl text-sm shadow-lg transition-transform hover:scale-[1.02] ${
                      c.color === 'orange'  ? 'bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-400 hover:to-amber-500' :
                      c.color === 'emerald' ? 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500' :
                      c.color === 'yellow'  ? 'bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-black' :
                      c.color === 'purple'  ? 'bg-gradient-to-r from-purple-500 to-fuchsia-600 hover:from-purple-400 hover:to-fuchsia-500' :
                      c.color === 'violet'  ? 'bg-gradient-to-r from-violet-500 to-indigo-600 hover:from-violet-400 hover:to-indigo-500' :
                      'bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-400 hover:to-cyan-500'
                    }`}
                  >
                    Enroll Now <ArrowRight className="w-4 h-4" />
                  </button>
                  <div className="mt-2">
                    <EnquireNowButton courseName={c.title} fullWidth size="sm" label="Enquire Now" variant="outline" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-14 flex flex-wrap items-center justify-center gap-6 text-center">
            {[
              { icon: <Award className="w-5 h-5" />, text: 'Industry Certification' },
              { icon: <Shield className="w-5 h-5" />, text: 'Placement Assistance' },
              { icon: <Globe className="w-5 h-5" />, text: '20+ Years Legacy' },
              { icon: <CheckCircle2 className="w-5 h-5" />, text: 'Offline + Online Hybrid' }
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-gray-400">
                <span className="text-yellow-500">{item.icon}</span>
                <span className="text-xs font-semibold">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Join Us + Career Outcomes — moved AFTER course explorer */}
      <WhyJoinUs />
      <CareerOutcomes />

      {/* COURSE COMPARISON TABLE */}
      <section className="py-20 px-6" style={{ background: 'linear-gradient(180deg, #0f172a 0%, #0a0a0a 100%)' }}>
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-black text-white mb-3 tracking-tight">Compare Courses</h2>
            <p className="text-gray-400 max-w-lg mx-auto">Side-by-side overview to help you pick the right program</p>
          </div>
          <div className="overflow-x-auto rounded-2xl border border-white/[0.08]">
            <table className="w-full text-left text-sm" data-testid="course-comparison-table">
              <thead>
                <tr className="bg-white/[0.04]">
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]">Course</th>
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]">Duration</th>
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]">Price</th>
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]">Discount</th>
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]">Batch Start</th>
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]">Career Outcome</th>
                  <th className="p-4 font-semibold text-gray-400 border-b border-white/[0.06]"></th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: 'AI Bootcamp (Students)', dur: '3 Months', old: '—', price: '50% OFF', disc: '50%', start: 'New Batches Every Month', outcome: 'AI foundations + certification', color: 'violet', link: '/ai-bootcamp' },
                  { name: 'Performance Marketing', dur: '4 Months', old: '—', price: 'Job Guarantee', disc: '—', start: 'New Batches Every Month', outcome: 'Meta/Google Ads expert', color: 'blue', link: '/performance-marketing' },
                  { name: 'Film Making & Animation', dur: '4 Months', old: '₹95,000', price: '₹35,000', disc: '63%', start: 'New Batches Every Month', outcome: 'VFX Artist / Film Editor', color: 'orange', link: '/film-making-animation-course' },
                  { name: 'Game Development', dur: '4 Months', old: '₹95,000', price: '₹35,000', disc: '63%', start: 'New Batches Every Month', outcome: 'Game Dev / 3D Artist', color: 'emerald', link: '/game-development-course' },
                  { name: 'Jewellery Design', dur: '2 Months', old: '₹49,000', price: '₹25,000', disc: '49%', start: 'New Batches Every Month', outcome: 'Jewellery Designer / CAD', color: 'yellow', link: '/jewellery-designing-course' },
                  { name: 'Blender & Character Design', dur: '4 Months', old: '₹75,000', price: '₹30,000', disc: '60%', start: 'New Batches Every Month', outcome: 'Character Artist / Animator', color: 'purple', link: '/complete-blender-character-design-course' }
                ].map((c, i) => (
                  <tr key={i} className="border-b border-white/[0.04] hover:bg-white/[0.03] transition-colors">
                    <td className="p-4"><span className={`font-semibold text-${c.color}-400`}>{c.name}</span></td>
                    <td className="p-4 text-gray-300">{c.dur}</td>
                    <td className="p-4"><span className="text-gray-500 line-through text-xs mr-1">{c.old}</span><span className="text-white font-bold">{c.price}</span></td>
                    <td className="p-4"><span className={`text-${c.color}-400 font-bold`}>{c.disc}</span></td>
                    <td className="p-4 text-gray-300">{c.start}</td>
                    <td className="p-4 text-gray-400">{c.outcome}</td>
                    <td className="p-4"><button onClick={() => navigate(c.link)} className={`text-xs font-semibold text-${c.color}-400 hover:underline whitespace-nowrap`}>View →</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* SECTION 2: UPCOMING FLAGSHIP COHORT - LEADERSHIP TRAINING STYLE */}
      <section className="relative py-16 px-6" style={{ backgroundColor: '#FFFFFF' }}>
        {/* Subtle Decorative Circular Lines */}
        <div className="absolute inset-0 opacity-3 pointer-events-none">
          <div className="absolute top-1/3 left-1/4 w-64 h-64 rounded-full border border-purple-500/20"></div>
          <div className="absolute bottom-1/3 right-1/4 w-48 h-48 rounded-full border border-blue-500/20"></div>
        </div>

        <div className="container mx-auto max-w-6xl relative z-10">
          {/* Central Light Card */}
          <div 
            className="rounded-[32px] p-8 lg:p-10 relative"
            style={{ 
              backgroundColor: '#F8F9FA',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)'
            }}
          >
            {/* Big Bold Heading at Top - Black NO UNDERLINE */}
            <div className="text-center mb-10">
              <h2 className="text-5xl lg:text-6xl font-black text-gray-900">
                Our Upcoming Legacy Cohort
              </h2>
            </div>

            <div className="grid lg:grid-cols-2 gap-8 items-start">
              {/* LEFT CONTENT COLUMN */}
              <div className="flex flex-col justify-center">
                {/* Program Title */}
                <h3 className="text-3xl lg:text-4xl font-black text-gray-900 mb-5 leading-tight">
                  Certified Specialist in Digital Growth & Performance Marketing (CSDGPM)
                </h3>

                {/* Subhead */}
                <p className="text-base text-gray-600 mb-5 font-medium">
                  Specialist-level program — Industry expert-led · Live classes + Labs + Projects
                </p>

                {/* Five Info Boxes - Bigger Size */}
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div 
                    className="flex items-center gap-3 px-5 py-4 rounded-xl"
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0.03)',
                      border: '1px solid rgba(26, 77, 255, 0.3)'
                    }}
                  >
                    <Calendar className="w-6 h-6" style={{ color: '#1A4DFF' }} />
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Next Cohort</p>
                      <p className="text-sm font-bold text-gray-900">New Batches Every Month</p>
                    </div>
                  </div>

                  <div 
                    className="flex items-center gap-3 px-5 py-4 rounded-xl relative"
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0.03)',
                      border: '1px solid rgba(26, 77, 255, 0.3)'
                    }}
                  >
                    <div className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                    <Users className="w-6 h-6" style={{ color: '#1A4DFF' }} />
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Seats Left</p>
                      <p className="text-sm font-bold text-gray-900">40 Only</p>
                    </div>
                  </div>

                  <div 
                    className="flex items-center gap-3 px-5 py-4 rounded-xl"
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0.03)',
                      border: '1px solid rgba(26, 77, 255, 0.3)'
                    }}
                  >
                    <Clock className="w-6 h-6" style={{ color: '#1A4DFF' }} />
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Duration</p>
                      <p className="text-sm font-bold text-gray-900">6 Months</p>
                    </div>
                  </div>

                  <div 
                    className="flex items-center gap-3 px-5 py-4 rounded-xl"
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0.03)',
                      border: '1px solid rgba(26, 77, 255, 0.3)'
                    }}
                  >
                    <BookOpen className="w-6 h-6" style={{ color: '#1A4DFF' }} />
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Training</p>
                      <p className="text-sm font-bold text-gray-900">150 Hours</p>
                    </div>
                  </div>

                  {/* NEW - Last Date of Admission - Highlighted */}
                  <div 
                    className="col-span-2 flex items-center justify-center gap-3 px-5 py-4 rounded-xl"
                    style={{
                      backgroundColor: 'rgba(255, 199, 39, 0.15)',
                      border: '2px solid #FFC727',
                      boxShadow: '0 0 15px rgba(255, 199, 39, 0.3)'
                    }}
                  >
                    <Star className="w-6 h-6" style={{ color: '#FFC727' }} />
                    <div className="text-center">
                      <p className="text-xs text-gray-600 mb-1">Last Date of Admission</p>
                      <p className="text-base font-black text-gray-900">New Batches Every Month</p>
                    </div>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-3">
                  <button 
                    onClick={() => navigate('/csdgpm-offer')}
                    className="px-6 py-3 rounded-xl font-bold text-base transition-all hover:scale-105 hover:shadow-lg inline-flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#FFC727', color: '#000000' }}
                  >
                    Enroll Now & Save 50%
                    <ArrowRight className="w-4 h-4" />
                  </button>
                  <button 
                    onClick={() => navigate('/csdgpm-offer')}
                    className="px-6 py-3 rounded-xl font-bold text-base transition-all hover:bg-gray-800"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', color: '#FFFFFF', border: '1px solid rgba(0, 0, 0, 0.9)' }}
                  >
                    View Course Details
                  </button>
                </div>
              </div>

              {/* RIGHT CONTENT COLUMN - Big Image Without Border or Shape */}
              <div className="hidden lg:block h-full">
                <img 
                  src="https://customer-assets.emergentagent.com/job_academy-revamp-2/artifacts/eib8maoq_Untitled%20design%20%285%29.jpg"
                  alt="Digital Marketing Professional"
                  className="w-full h-full object-cover rounded-2xl"
                  style={{ minHeight: '550px', maxHeight: '650px' }} decoding="async" loading="lazy" />
              </div>
            </div>

            {/* Powered by Workshop Library + Badges - Center Bottom in One Long Line */}
            <div className="text-center mt-8 pt-6 border-t border-gray-200">
              <div className="flex flex-wrap items-center justify-center gap-4">
                {/* Powered by Workshop Library */}
                <a 
                  href="https://workshoplibrary.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 hover:opacity-70 transition-opacity"
                >
                  <span className="text-sm font-bold text-gray-600">Powered by</span>
                  <img 
                    src="https://customer-assets.emergentagent.com/job_eduai-portal-6/artifacts/zrncz5al_Untitled%20%281000%20x%20500%20px%29%20%281%29.jpg"
                    alt="Workshop Library"
                    className="h-6 object-contain" decoding="async" loading="lazy" />
                </a>

                {/* Separator */}
                <div className="w-px h-8 bg-gray-300"></div>

                {/* Exemplar Global Badge */}
                <div 
                  className="flex items-center gap-2 px-5 py-2 rounded-full"
                  style={{
                    backgroundColor: 'rgba(107, 91, 255, 0.1)',
                    border: '2px solid #6B5BFF',
                    boxShadow: '0 0 10px rgba(107, 91, 255, 0.2)'
                  }}
                >
                  <img 
                    src="https://customer-assets.emergentagent.com/job_eduai-portal-6/artifacts/qvi4oewl_exempler%20logo.webp"
                    alt="Exemplar Global"
                    className="h-5 object-contain" decoding="async" loading="lazy" />
                  <span className="text-gray-900 font-bold text-xs">Exemplar Global Certified</span>
                </div>

                {/* Google Ads Badge */}
                <div 
                  className="flex items-center gap-2 px-5 py-2 rounded-full"
                  style={{
                    backgroundColor: 'rgba(26, 77, 255, 0.1)',
                    border: '2px solid #1A4DFF',
                    boxShadow: '0 0 10px rgba(26, 77, 255, 0.2)'
                  }}
                >
                  <div className="w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center">
                    <span className="text-white font-bold text-[10px]">G</span>
                  </div>
                  <span className="text-gray-900 font-bold text-xs">Google Ads Certification Ready</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* SECTION 3: OUR PROGRAMS (LIVE vs COMING SOON) */}
      <section id="courses" className="py-32 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto max-w-7xl">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Our Programs</h2>
            <p className="text-2xl text-gray-600 max-w-3xl mx-auto">Professional certifications designed to accelerate your career in high-demand fields</p>
            <button 
              onClick={() => document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="mt-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-3 rounded-xl font-bold text-lg shadow-lg hover:scale-105 transition-all inline-flex items-center gap-2"
            >
              Enroll in a Program
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* GLOBAL HEADER - Exemplar Global Authorization */}
          <div className="mb-12 py-6 px-10 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border-2 border-blue-200 shadow-lg max-w-5xl mx-auto">
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <h3 className="text-2xl font-bold text-gray-900">Authorised Training Certifications through</h3>
              <div className="flex items-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_ai-workshops/artifacts/sp9brvsf_exempler%20logo.webp" 
                  alt="Exemplar Global" 
                  className="h-16 object-contain" decoding="async" loading="lazy" />
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((course) => (
              <div 
                key={course.id}
                className={`group relative rounded-3xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-xl ${
                  course.isLive 
                    ? 'ring-4 ring-yellow-400/50' 
                    : 'ring-2 ring-blue-200/50'
                }`}
              >
                <div className={`bg-white border-2 ${course.isLive ? 'border-yellow-400 shadow-yellow-200/50' : 'border-gray-200'} rounded-3xl overflow-hidden h-full flex flex-col`}>
                  {/* Limited Time 50% OFF Corner Badge - Only for Live Course */}
                  {course.isLive && (
                    <div className="absolute top-0 right-0 z-20">
                      <div className="relative">
                        <div className="bg-gradient-to-br from-red-500 to-orange-500 text-white px-6 py-3 rounded-bl-3xl shadow-2xl">
                          <div className="flex flex-col items-center">
                            <span className="text-xs font-bold uppercase tracking-wider">Limited Time</span>
                            <span className="text-2xl font-black leading-tight">50% OFF</span>
                          </div>
                        </div>
                        <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-t-red-600 border-l-[20px] border-l-transparent"></div>
                      </div>
                    </div>
                  )}

                  {course.isLive && (
                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-orange-400/20 animate-pulse pointer-events-none"></div>
                  )}

                  <div className="h-48 overflow-hidden relative">
                    <img 
                      src={course.image} 
                      alt={course.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" decoding="async" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
                  </div>

                  <div className="p-6 flex-1 flex flex-col">
                    {/* Status & Certification Badges - Above Title */}
                    <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
                      <div className="flex items-center gap-2">
                        {course.isLive ? (
                          <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 px-3 py-1.5 rounded-full font-bold text-xs shadow-md flex items-center gap-1.5">
                            <Sparkles className="w-3 h-3" />
                            <span>Enrollment Open</span>
                          </div>
                        ) : (
                          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-3 py-1.5 rounded-full font-semibold text-xs shadow-md flex items-center gap-1.5">
                            <span>🚀</span>
                            <span>Launching Soon</span>
                          </div>
                        )}
                      </div>
                      <div className="bg-white px-2 py-1 rounded-md border border-blue-200">
                        <img 
                          src="https://customer-assets.emergentagent.com/job_ai-workshops/artifacts/sp9brvsf_exempler%20logo.webp" 
                          alt="Exemplar" 
                          className="h-5 object-contain" decoding="async" loading="lazy" />
                      </div>
                    </div>
                    
                    {/* Level & Duration Badges */}
                    <div className="flex items-center gap-2 mb-3">
                      <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100 text-sm px-3 py-1.5 font-bold">{course.level}</Badge>
                      <Badge className="bg-gray-100 text-gray-700 hover:bg-gray-100 text-sm px-3 py-1.5 font-bold">{course.duration}</Badge>
                    </div>
                    
                    {/* Course Title */}
                    <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">{course.title}</h3>
                    
                    {/* Commencement Date for Live Course */}
                    {course.isLive && (
                      <div className="mb-3 flex items-center gap-2">
                        <Calendar className="w-4 h-4 text-blue-600" />
                        <p className="text-sm font-semibold text-gray-700">
                          <span className="text-gray-500">Commencing on:</span> <span className="text-blue-700">New Batches Every Month</span>
                        </p>
                      </div>
                    )}
                    
                    <p className="text-gray-600 mb-6 leading-relaxed flex-1">{course.description}</p>
                    
                    {course.isLive ? (
                      <>
                        <div className="flex gap-3 mb-4">
                          <button 
                            onClick={() => navigate(course.detailUrl)}
                            className="flex-1 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                          >
                            View Details
                            <ArrowRight className="w-4 h-4" />
                          </button>
                          <button 
                            onClick={() => document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' })}
                            className="flex-1 border-2 border-blue-600 text-blue-600 hover:bg-blue-50 py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2"
                          >
                            Enquire Now
                          </button>
                        </div>
                        
                        {/* Ticker for Live Course */}
                        <div className="overflow-hidden bg-gradient-to-r from-yellow-50 via-amber-50 to-yellow-50 rounded-lg border border-yellow-200 py-2.5">
                          <div className="flex animate-scroll whitespace-nowrap">
                            <span className="inline-flex items-center gap-2 text-sm font-bold text-gray-800 px-4">
                              ⭐ 100+ Students Enrolled
                            </span>
                            <span className="inline-flex items-center gap-2 text-sm font-bold text-gray-800 px-4">
                              🔥 Limited Seats Available
                            </span>
                            <span className="inline-flex items-center gap-2 text-sm font-bold text-gray-800 px-4">
                              📅 New Batches Every Month
                            </span>
                            <span className="inline-flex items-center gap-2 text-sm font-bold text-gray-800 px-4">
                              ⏰ Enrollment Closes: New Batches Every Month
                            </span>
                            <span className="inline-flex items-center gap-2 text-sm font-bold text-gray-800 px-4">
                              🎓 Industry Expert Led
                            </span>
                            <span className="inline-flex items-center gap-2 text-sm font-bold text-gray-800 px-4">
                              ⭐ 100+ Students Enrolled
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="flex gap-3">
                        <button 
                          onClick={() => document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' })}
                          className="flex-1 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                        >
                          Enquire Now
                          <ArrowRight className="w-4 h-4" />
                        </button>
                        {course.comingSoon && (
                          <div className="flex-1 bg-gray-100 text-gray-500 py-3 rounded-xl font-bold flex items-center justify-center gap-2">
                            Coming Soon
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 4: UPCOMING SHORT-TERM AI WORKSHOPS (NEW) */}
      <section id="workshops" className="relative py-32 px-6 bg-gradient-to-b from-blue-50 to-white overflow-hidden">
        {/* Curved Top Divider */}
        <div className="absolute top-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" className="w-full h-24 fill-white">
            <path d="M0,64 C240,120 480,120 720,96 C960,72 1200,24 1440,48 L1440,0 L0,0 Z"></path>
          </svg>
        </div>

        {/* Floating Shapes */}
        <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-200 rounded-full blur-3xl opacity-20"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-200 rounded-full blur-3xl opacity-20"></div>

        <div className="container mx-auto max-w-7xl relative z-10 pt-16">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Upcoming Short-Term AI Workshops</h2>
            <p className="text-2xl text-gray-600 max-w-3xl mx-auto">Enhance your skills with fast, practical, career-ready micro courses</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {workshops.map((workshop) => (
              <div 
                key={workshop.id}
                className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100"
              >
                {/* Workshop Image */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={workshop.image}
                    alt={workshop.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" decoding="async" loading="lazy" />
                  <div className={`absolute inset-0 bg-gradient-to-t ${workshop.color} opacity-40`}></div>
                  
                  {/* 50% OFF Corner Badge */}
                  <div className="absolute top-0 right-0 z-20">
                    <div className="relative">
                      <div className="bg-gradient-to-br from-red-500 to-orange-500 text-white px-5 py-2.5 rounded-bl-2xl shadow-xl">
                        <div className="flex flex-col items-center">
                          <span className="text-[10px] font-bold uppercase tracking-wide">Limited Time</span>
                          <span className="text-lg font-black leading-tight">50% OFF</span>
                        </div>
                      </div>
                      <div className="absolute top-0 right-0 w-0 h-0 border-t-[15px] border-t-red-600 border-l-[15px] border-l-transparent"></div>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <Badge className="bg-blue-50 text-blue-700 text-xs">{workshop.duration}</Badge>
                    <Badge className="bg-green-50 text-green-700 text-xs">Starts {workshop.startDate}</Badge>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight">{workshop.title}</h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed">{workshop.description}</p>
                  
                  {/* Premium Price & Date Card */}
                  <div className="mb-4 bg-white rounded-xl border-2 border-gray-200 shadow-sm overflow-hidden">
                    {/* Price Section */}
                    <div className="p-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-center">
                      <p className="text-xs uppercase tracking-wide opacity-80 mb-2">Workshop Fee</p>
                      <div className="flex items-center justify-center gap-3 mb-2">
                        <span className="text-xl line-through opacity-70">$100</span>
                        <span className="text-4xl font-black">$50</span>
                      </div>
                      <p className="text-xs opacity-90 font-semibold">Save $50 Today</p>
                    </div>
                    
                    {/* Date Section */}
                    <div className="p-4 bg-gray-50 text-center">
                      <div className="flex items-center justify-center gap-2 mb-1">
                        <Calendar className="w-4 h-4 text-blue-600" />
                        <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Starts</span>
                      </div>
                      <p className="text-base font-bold text-gray-900">{workshop.startDate}</p>
                    </div>
                    
                    {/* Enrollment Deadline Ticker */}
                    <div className="bg-gradient-to-r from-red-600 to-orange-500 text-white text-center py-2.5">
                      <p className="text-xs font-bold tracking-wide">⏰ Enrollment closes {workshop.enrollmentDeadline}</p>
                    </div>
                  </div>
                  
                  {/* Button */}
                  {workshop.id === 1 ? (
                    <button 
                      onClick={() => navigate('/workshops/photo-editing-ai')}
                      className="w-full bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 2 ? (
                    <button 
                      onClick={() => navigate('/workshops/video-editing-reels')}
                      className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 3 ? (
                    <button 
                      onClick={() => navigate('/workshops/social-media-booster')}
                      className="w-full bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 4 ? (
                    <button 
                      onClick={() => navigate('/workshops/linkedin-personal-branding')}
                      className="w-full bg-gradient-to-r from-blue-700 to-gray-800 hover:from-blue-800 hover:to-gray-900 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 5 ? (
                    <button 
                      onClick={() => navigate('/workshops/prompt-engineering')}
                      className="w-full bg-gradient-to-r from-emerald-500 to-purple-600 hover:from-emerald-600 hover:to-purple-700 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 6 ? (
                    <button 
                      onClick={() => navigate('/workshops/canva-design-secrets')}
                      className="w-full bg-gradient-to-r from-pink-500 to-orange-500 hover:from-pink-600 hover:to-orange-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 7 ? (
                    <button 
                      onClick={() => navigate('/workshops/freelancing-side-income')}
                      className="w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 8 ? (
                    <button 
                      onClick={() => navigate('/workshops/digital-ads-automation')}
                      className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 9 ? (
                    <button 
                      onClick={() => navigate('/workshops/content-creation-mastery')}
                      className="w-full bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : workshop.id === 10 ? (
                    <button 
                      onClick={() => navigate('/workshops/resume-portfolio-builder')}
                      className="w-full bg-gradient-to-r from-slate-600 to-blue-600 hover:from-slate-700 hover:to-blue-700 text-white py-3 rounded-xl font-bold text-sm shadow-lg hover:shadow-xl transition-all"
                    >
                      View Workshop Details
                    </button>
                  ) : (
                    <button 
                      disabled
                      className="w-full bg-gray-100 text-gray-400 py-3 rounded-xl font-bold text-sm cursor-not-allowed"
                    >
                      Coming Soon
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Additional Workshops Grid - Remaining 2 */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-6">
            {/* Filler for layout if needed */}
          </div>
        </div>
      </section>
      {/* SECTION 5: ABOUT AI SCHOOL FOR ALL */}
      <section id="about" className="py-32 px-6 bg-white">
        <div className="container mx-auto max-w-7xl">
          {/* Single Line Heading */}
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-16 text-center">About AI School for All</h2>
          
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left: Image with Exemplar below */}
            <div>
              <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-6">
                <img 
                  src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=600&fit=crop&q=80"
                  alt="Modern AI Learning Environment"
                  className="w-full h-[400px] object-cover" decoding="async" loading="lazy" />
              </div>
              
              {/* Exemplar Certification under photo */}
              <div className="flex items-start gap-4">
                <a href="https://exemplarglobal.org" target="_blank" rel="noopener noreferrer" className="flex-shrink-0">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_eduai-portal-6/artifacts/qvi4oewl_exempler%20logo.webp"
                    alt="Exemplar Global"
                    className="h-16 object-contain hover:opacity-80 transition-opacity" decoding="async" loading="lazy" />
                </a>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Exemplar Global Certified</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">Globally recognized accreditation for professional training programs ensuring highest quality standards.</p>
                  <p className="text-sm text-gray-600 mt-1">Programs designed and certified by Exemplar Global for worldwide recognition.</p>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div>
              <p className="text-2xl text-gray-600 mb-6 leading-relaxed">
                We are a <span className="font-bold text-blue-600">globally recognized training institution</span> specializing in professional certifications for AI, Data Science, Digital Marketing, and Cloud Computing.
              </p>
              <p className="text-xl text-gray-600 mb-10 leading-relaxed">
                Since 2011, we've trained over 30,000 professionals worldwide, helping them achieve career transformation through industry-recognized certifications, practical skills, and expert mentorship.
              </p>

              {/* Statistics Row */}
              <div className="grid grid-cols-3 gap-6 mb-10">
                <div className="text-center p-6 bg-blue-50 rounded-2xl">
                  <div className="text-4xl font-bold text-blue-600 mb-2">14+</div>
                  <div className="text-sm text-gray-600 font-medium">Years Experience</div>
                </div>
                <div className="text-center p-6 bg-purple-50 rounded-2xl">
                  <div className="text-4xl font-bold text-purple-600 mb-2">30K+</div>
                  <div className="text-sm text-gray-600 font-medium">Students Trained</div>
                </div>
                <div className="text-center p-6 bg-green-50 rounded-2xl">
                  <div className="text-4xl font-bold text-green-600 mb-2">150+</div>
                  <div className="text-sm text-gray-600 font-medium">Hiring Partners</div>
                </div>
              </div>

              {/* Powered by Workshop Library - bottom right without border */}
              <div className="text-right">
                <a 
                  href="https://workshoplibrary.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                >
                  <span className="text-sm font-semibold">Powered by</span>
                  <img 
                    src="https://customer-assets.emergentagent.com/job_eduai-portal-6/artifacts/zrncz5al_Untitled%20%281000%20x%20500%20px%29%20%281%29.jpg"
                    alt="Workshop Library"
                    className="h-6 object-contain" decoding="async" loading="lazy" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7: ADDITIONAL BENEFITS */}
      <section className="relative py-32 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Additional Benefits</h2>
            <p className="text-2xl text-gray-600">Everything you need to succeed in your learning journey</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                title: 'Hands-On Projects',
                description: 'Build real-world projects that showcase your skills to employers and clients.',
                color: 'from-blue-400 to-blue-500'
              },
              {
                title: 'State-of-the-Art Learning',
                description: 'Access latest curriculum updated with industry trends and cutting-edge tools.',
                color: 'from-purple-400 to-purple-500'
              },
              {
                title: 'Flexible Learning',
                description: 'Live sessions with recorded content available for review at your convenience.',
                color: 'from-green-400 to-green-500'
              },
              {
                title: 'Placement Support',
                description: 'Career guidance, interview prep, and connections to our hiring partner network.',
                color: 'from-orange-400 to-orange-500'
              }
            ].map((benefit, index) => (
              <div 
                key={index} 
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 h-full"
                style={{ minHeight: '220px' }}
              >
                <div className={`h-1 w-16 rounded-full bg-gradient-to-r ${benefit.color} mb-6`}></div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 6: WHY CHOOSE AI SCHOOL FOR ALL - NEW LAYOUT */}
      <section id="why-choose" className="py-32 px-6 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto max-w-7xl">
          {/* Heading */}
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-20 text-center">Why Choose AI School for All?</h2>
          
          {/* Staggered Diagonal Grid Layout - Non-monotonous */}
          <div className="space-y-24">
            {/* Row 1: Image Left, Text Right */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-3xl blur-2xl"></div>
                <img 
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop&q=80"
                  alt="Industry Expert Trainers"
                  className="relative rounded-3xl shadow-2xl w-full h-[400px] object-cover" decoding="async" loading="lazy" />
              </div>
              <div className="space-y-6">
                <div className="inline-block px-4 py-2 bg-blue-100 rounded-full">
                  <span className="text-blue-700 font-bold text-sm">Expert Faculty</span>
                </div>
                <h3 className="text-4xl font-bold text-gray-900">Learn from Industry Leaders</h3>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Our trainers are seasoned professionals with 10+ years of real-world experience. They bring practical insights from Fortune 500 companies and startups alike.
                </p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                    <span>Working professionals from Google, Microsoft, Meta</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                    <span>Industry-recognized certifications and credentials</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Row 2: Text Left, Image Right (Reversed) */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6 lg:order-1">
                <div className="inline-block px-4 py-2 bg-purple-100 rounded-full">
                  <span className="text-purple-700 font-bold text-sm">Global Recognition</span>
                </div>
                <h3 className="text-4xl font-bold text-gray-900">Exemplar Global Certified Programs</h3>
                <p className="text-xl text-gray-600 leading-relaxed">
                  All our programs are accredited by Exemplar Global, ensuring worldwide recognition and the highest quality standards in professional training.
                </p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                    <span>Internationally recognized certifications</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                    <span>Accepted by employers in 100+ countries</span>
                  </li>
                </ul>
              </div>
              <div className="relative lg:order-2">
                <div className="absolute -inset-4 bg-gradient-to-br from-purple-400/20 to-pink-400/20 rounded-3xl blur-2xl"></div>
                <img 
                  src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&h=600&fit=crop&q=80"
                  alt="Global Certifications"
                  className="relative rounded-3xl shadow-2xl w-full h-[400px] object-cover" decoding="async" loading="lazy" />
              </div>
            </div>

            {/* Row 3: Image Left, Text Right */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-green-400/20 to-blue-400/20 rounded-3xl blur-2xl"></div>
                <img 
                  src="https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&h=600&fit=crop&q=80"
                  alt="Hands-on Learning"
                  className="relative rounded-3xl shadow-2xl w-full h-[400px] object-cover" decoding="async" loading="lazy" />
              </div>
              <div className="space-y-6">
                <div className="inline-block px-4 py-2 bg-green-100 rounded-full">
                  <span className="text-green-700 font-bold text-sm">Practical Approach</span>
                </div>
                <h3 className="text-4xl font-bold text-gray-900">Hands-On Project-Based Learning</h3>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Move beyond theory with real-world projects, case studies, and simulations. Build a portfolio that demonstrates your expertise to potential employers.
                </p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                    <span>Live projects with real company scenarios</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                    <span>Build job-ready portfolio during training</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-20">
            <button 
              onClick={() => document.getElementById('enrollment-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 px-10 py-5 rounded-2xl font-bold text-xl shadow-2xl hover:scale-105 transition-all inline-flex items-center gap-3"
            >
              Join Our Community
              <ArrowRight className="w-6 h-6" />
            </button>
          </div>
        </div>
      </section>

      {/* SECTION 8: WHAT ALUMNI SAY */}
      <section id="testimonials" className="py-32 px-6 bg-white">
        <div className="container mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">What Alumni Say</h2>
            <p className="text-2xl text-gray-600">Success stories from our graduates</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed italic text-lg">"{testimonial.quote}"</p>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                    <p className="text-xs text-gray-500">{testimonial.company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 9: FAQ (ENHANCED) */}
      <section id="faq" className="py-32 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
            <p className="text-2xl text-gray-600">Everything you need to know about our programs</p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`faq-${index}`}
                className="bg-white border-2 border-gray-200 rounded-2xl px-6 hover:border-blue-300 hover:shadow-lg transition-all overflow-hidden"
              >
                <AccordionTrigger className="hover:no-underline py-6">
                  <div className="flex items-center gap-4 text-left">
                    <div className="flex-shrink-0">{faq.icon}</div>
                    <span className="font-semibold text-lg text-gray-900">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-gray-700 leading-relaxed text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* SECTION 10: ENROLLMENT FORM (ENHANCED) */}
      {/* Free AI Career Masterclass funnel */}
      <MasterclassFunnel />

      {/* Logo wall — students working at top brands */}
      <LogoWall />

      <section id="enrollment-form" className="py-32 px-6 bg-gradient-to-b from-white to-blue-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, #3b82f6 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
        </div>

        <div className="container mx-auto max-w-4xl relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex flex-wrap items-center justify-center gap-6 bg-white px-8 py-4 rounded-2xl shadow-lg border border-gray-200 mb-10">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <span className="font-semibold text-gray-900">Exemplar Global Accredited</span>
              </div>
              <div className="hidden sm:block w-px h-6 bg-gray-300"></div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <span className="font-semibold text-gray-900">30,000+ Students</span>
              </div>
              <div className="hidden sm:block w-px h-6 bg-gray-300"></div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <span className="font-semibold text-gray-900">14+ Years Excellence</span>
              </div>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Start Your Journey Today</h2>
            <p className="text-2xl text-gray-600">Enroll now and transform your career with globally recognized certification</p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border border-gray-200">
            <EnrollmentForm />
          </div>
        </div>
      </section>

      {/* SECTION 11: FOOTER */}
      <MobileCTABar courseName="AI School for All" />
      <SiteFooter accent="blue" />

      {/* Chatbot */}
      <Chatbot />

      {/* Sticky mobile bottom CTA — Call / WhatsApp / Book Demo */}
      <StickyMobileCTA />

      {/* Custom Animations */}
      <style>{`
        @keyframes scroll-slow {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-slow {
          animation: scroll-slow 30s linear infinite;
        }
        @keyframes shine {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
        .animate-shine {
          animation: shine 3s infinite;
        }
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 15s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
